export default __webpack_public_path__ + "static/media/worker.84cdc322.png";